import { ExpandMore } from '@mui/icons-material';
import { Divider, Tooltip } from '@mui/material';
import { AnimatePresence, motion } from 'framer-motion';
import React, { type FC, useState, useRef } from 'react';
import { CodeBlock } from 'react-code-block';
import {
  StyledPlayerCardGenerator,
  StyledCodeBlockToken,
  StyledCodeBlockLineContent,
  StyledButton,
  StyledPromptsMenu,
  StyledCardElement,
  StyledPlayerName,
  StyledPlayerImage,
  StyledIconButton,
} from './ComponentSlot.styles';
import type {
  CustomComponentProps,
  PlayerCardGeneratorProps,
} from './ComponentSlot.types';

export const PlayerCardGenerator: FC<CustomComponentProps> = ({ props }) => {
  const { playerImage, prompts } = props as unknown as PlayerCardGeneratorProps;
  const [currentPromptIndex, setCurrentPromptIndex] = useState<number>(0);
  const [expanded, setExpanded] = useState<boolean>(false);
  const ref = useRef<HTMLDivElement>(null);

  return (
    <StyledPlayerCardGenerator expanded={expanded} ref={ref}>
      <StyledCardElement>
        <StyledPlayerImage src={playerImage} />
        <StyledPlayerName>Adam Joseph</StyledPlayerName>
      </StyledCardElement>
      <StyledCardElement>
        <StyledPromptsMenu>
          {prompts.map((prompt, index) => (
            <StyledButton
              active={currentPromptIndex === index}
              key={index}
              onClick={() => {
                setCurrentPromptIndex(index);
              }}
              disabled={currentPromptIndex === index}>
              {prompt.title}
            </StyledButton>
          ))}
          <Divider
            sx={{
              flex: '1',
            }}
          />
          <Tooltip title={expanded ? 'Collapse' : 'Expand'} placement="top">
            <StyledIconButton
              onClick={() => setExpanded(!expanded)}
              sx={{
                transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
              }}>
              <ExpandMore />
            </StyledIconButton>
          </Tooltip>
        </StyledPromptsMenu>
        <AnimatePresence mode="wait">
          <motion.div
            key={currentPromptIndex}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}>
            <CodeBlock
              code={prompts[currentPromptIndex].code}
              language="javascript">
              <CodeBlock.Code>
                <StyledCodeBlockLineContent>
                  <StyledCodeBlockToken />
                </StyledCodeBlockLineContent>
              </CodeBlock.Code>
            </CodeBlock>
          </motion.div>
        </AnimatePresence>
      </StyledCardElement>
    </StyledPlayerCardGenerator>
  );
};
